import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

const useGeoCMSData = () => {
  const { t } = useTranslation();

  const data = useMemo(
    () => ({
      data: {
        GeoPage: {
          // Basic labels
          showMapLabel: t('geo:show_map'),
          filterLabel: t('geo:filter'),
          eagleRiderLabel: t('geo:eagle_rider'),
          byEagleRiderLabel: t('geo:by_eagle_rider'),
          dayLabel: t('geo:day'),
          clearFiltersLabel: t('geo:clear_filters'),
          allLabel: t('geo:all'),
          searchLabel: t('geo:search'),
          motorcycleLabel: t('geo:motorcycle'),
          motorcyclesLabel: t('geo:motorcycles'),
          smallMotorcycleLabel: t('geo:motorcycle_small'),
          filtersLabel: t('geo:filters'),
          clearAllLabel: t('geo:clear_filter_label'),
          addDatePlaceHolder: t('geo:add_dates'),
          pickupCalenderLabel: t('geo:pick_up'),
          dropoffCalenderLabel: t('geo:drop_off'),
          calenderDialogTitleOnMobile: t('geo:choose_your_dates'),
          // Location-related labels
          inLabel: t('geo:in'),
          nearLabel: t('geo:near'),
          rentalsLabel: t('geo:rentals'),
          allRentalsLabel: t('geo:all_rentals'),
          erRentalsLabel: t('geo:er_rentals'),
          allERRentalsLabel: t('geo:all_er_rentals'),
          allERRentalsInLabelLocation: t('geo:all_rentals_in_location'),
          allERNearRentalsNearLocationLabel: t('geo:all_rentals_near_location'),
          usLabel: t('geo:the_US'),
          cityLabel: t('geo:the_city'),

          searchDestinationsLabel: t('geo:search_distinations'),
          pickupLabel: t('geo:pickup'),
          dropoffLabel: t('geo:dropoff'),
          dropoffLocationLabel: t('geo:dropoff_label'),
          returnToSameLabel: t('geo:return_to_same'),
          useCurrentLocationLabel: t('geo:use_current_location'),
          currentLocationLabel: t('geo:current_location'),
          whenRidingLabel: t('geo:when_riding'),
          chooseDestinationFilterTitle: t('geo:choose_destination'),
          saveSearchLabel: t('geo:save_search'),
          pickupAndDropoffLabel: t('geo:pickup_and_dropoff'),

          // Filter-related labels
          allTypesLabel: t('geo:all_types'),
          allMakesLabel: t('geo:all_makes'),
          allModelsLabel: t('geo:all_models'),
          vehicleMakeLabel: t('geo:vehicle_make'),
          vehicleTypeLabel: t('geo:vehicle_type'),
          allVehicleTypesLabel: t('geo:all_vehicle_types'),
          vehicleModelLabel: t('geo:vehicle_model'),
          addDatesLabel: t('geo:add_dates'),

          // Error/empty states
          noRentalsLabelAvailable: t('geo:no_rentals'),
          noRentalsLabelsAvailableDescription: t('geo:no_tours_available_description'),
          clearFiltersButtonLabel: t('geo:clear_filters'),
          locationBlockedMsg: t('geo:location_blocked_msg'),
          mapFailedLabel: t('geo:map_failed'),

          // Description texts
          erHoldingDescription: t('geo:er_holding_description'),
          availableForRentLabel: t('geo:available_for_rent'),
          disableReturnLocationLabel: t('geo:disable_return_location'),
          datePickerInfoLabel: t('geo:date_picker_info'),
          disableReturnToSameLabel: t('geo:disable_return_to_same'),
          useCurrentLocationText: t('geo:use_location'),

          // Dynamic content Labels
          lookingToRentLabel: t('geo:looking_to_rent'),
          whetherRentingLabel: t('geo:Whether_renting_or_explore'),
          rentalsByCountryLabel: t('geo:rentals_by_country'),
          rentalsNameLabel: t('geo:rentals_name'),
          rentalsNameInLabel: t('geo:rentals_name_in'),
          rentalsNameNearLabel: t('geo:rentals_name_near'),
          rentalsInLabel: t('geo:rentals_in'),
          rentalsNearLabel: t('geo:rentals_near'),
          rentalsInNameByLabel: t('geo:rentals_in_name_by'),
          rentalsNearNameByLabel: t('geo:rentals_near_name_by'),
          // Additional dynamic content
          allRentalsInGeographyLabel: t('geo:all_rentals_in_geography'),
          allRentalsNearGeographyLabel: t('geo:all_rentals_near_geography'),
          rentalsByCityLabel: t('geo:rentals_by_city'),
          rentalsByVehicleModelLabel: t('geo:rentals_by_vehicle_model'),
          rentalsByVehicleModelInLabel: t('geo:rentals_by_vehicle_model_in'),
          rentalsByVehicleModelNearLabel: t('geo:rentals_by_vehicle_model_near'),
          rentalsNearbyPlaceLabel: t('geo:rentals_nearby_place'),
          rentalsByRegionLabel: t('geo:rentals_by_region'),
          similarRentalsLabel: t('geo:similar_rentals'),
          similarRentalsInLabel: t('geo:similar_rentals_in'),
          similarRentalsNearLabel: t('geo:similar_rentals_near'),
          pricePerDayLabel: t('geo:price_per_day'),

          // Count-related Labels
          numberModelsAvailableForRentLabel: t('geo:number_models_available_for_rent'),
          numberModelsAvailableForRentInLocationLabel: t('geo:number_models_available_for_rent_in_location'),
          numberModelsAvailableForRentNearLocationLabel: t('geo:number_models_available_for_rent_near_location'),
          numberMakesTypesAvailableForRentLabel: t('geo:number_makes_types_available_for_rent'),
          numberMakesTypesAvailableForRentInLocationLabel: t('geo:number_makes_types_available_for_rent_in_location'),
          numberMakesTypesAvailableForRentNearLocationLabel: t('geo:number_makes_types_available_for_rent_near_location'),

          // Rental type Labels
          rentalTypeslabel: t('geo:rental_types'),
          rentalTypesInLocationlabel: t('geo:rental_types_in_location'),
          rentalTypesNearLocationlabel: t('geo:rental_types_near_location'),
          searchThisAreaLabel: t('geo:search_this_area'),
        },
        RentalsCardComponent: {
          startingAt: t('common_rentals_card:start_at'),
          viewBikeSpecs: t('common_rentals_card:view_bike_specs'),
          pricePerDayText: t('common_rentals_card:price_per_day'),
          valueDealLabel: t('common_rentals_card:deal_value'),
          limitedAvailabilityLabel: t('common_rentals_card:limited_availability'),
          leftedVehicleOnPriceLabel: t('common_rentals_card:lefted_vehicle'),
          soldOutLabel: t('common_rentals_card:sold_out'),
          erLocationName: t('common_rentals_card:er_location_name'),

        },
        EagleSharePromoComponent: {
          title: t('common_es_promo:can’t_find_the_perfect_ride'),
          buttonLabel: t('common_es_promo:see_more_es'),
          esBikes: [
            {
              id: 1,
              title: 'BMW',
              subTitle: 'K 1600 GTL',
              image: {
                sizes: {
                  small_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-1.jpg',
                  },
                  medium_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-1.jpg',
                  },
                  large_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-1.jpg',
                  },
                  xlarge_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-1.jpg',
                  },
                },
                alt: 'promo-img',

              },
            },
            {
              id: 2,
              title: 'DUCATI',
              subTitle: 'MULTISTRADA V2',
              image: {
                sizes: {
                  small_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-2.jpg',
                  },
                  medium_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-2.jpg',
                  },
                  large_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-2.jpg',
                  },
                  xlarge_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-2.jpg',
                  },
                },
                alt: 'promo-img',
              },
            },
            {
              id: 3,
              title: 'HARLEY-DAVIDSON',
              subTitle: 'STREET GLIDE ST',
              image: {
                sizes: {
                  small_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-3.jpg',
                  },
                  medium_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-3.jpg',
                  },
                  large_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-3.jpg',
                  },
                  xlarge_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-3.jpg',
                  },
                },
                alt: 'promo-img',
              },
            },
            {
              id: 4,
              title: 'YAMAHA',
              subTitle: 'XSR700',
              image: {
                sizes: {
                  small_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-4.png',
                  },
                  medium_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-4.png',
                  },
                  large_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-4.png',
                  },
                  xlarge_url: {
                    url: '/imgs/Rebranding/es-promo/es-promo-4.png',
                  },
                },
                alt: 'promo-img',
              },
            },
          ],

        },
        MainWidgetDialogComponent: {
          startYourAdventureLabel: t('common_main_widget_dialog_v2:start_your_adventure'),
        },
        NewMainWidgetComponent: {
          rentMotorcycle: t('common_new_main_widget:rent_motorcycle'),
          allMotorcycleTours: t('common_new_main_widget:all_motorcycle_tours'),
          guidedMotorcycleTours: t('common_new_main_widget:guided_motorcycle_tours'),
          selfDriveMotorcycleTours: t('common_new_main_widget:self_drive_motorcycle_tours'),
          returnToSameLocation: t('common_new_main_widget:return_to_same_location'),
          searchTour: t('common_new_main_widget:search_tour'),
          tourTypeLabel: t('common_new_main_widget:tour_type'),
          countryLabel: t('common_new_main_widget:country_label'),
          stateNameLabel: t('common_new_main_widget:state_name_label'),
          tourTabLabel: t('common_new_main_widget:tour_tab_label'),
          rentalTabLabel: t('common_new_main_widget:rental_tab_label'),
          country: t('common_new_main_widget:country'),
          stateName: t('common_new_main_widget:state_name'),
          futureBookings: t('common_new_main_widget:future_bookings'),
          saveEvenMore: t('common_new_main_widget:save_even_more'),
          rideRoundTripOrOneWay: t('common_new_main_widget:can_ride_rounded_trip_or_one_way'),
          startYourReservation: t('common_new_main_widget:start_your_reservation'),
          pickupLocation: t('common_new_main_widget:pickup_location'),
          choosePickupLocation: t('common_new_main_widget:choose_pickup_location'),
          dropoffLocation: t('common_new_main_widget:dropoff_location'),
          chooseDropoffLocation: t('common_new_main_widget:choose_dropoff_location'),
          sameAsPickupLocation: t('common_new_main_widget:same_as_pickup_location'),
          dropoffLocationError: t('common_new_main_widget:dropoff_location_error'),
          pickupDateLabel: t('common_new_main_widget:pickup_date_label'),
          dropoffDateLabel: t('common_new_main_widget:dropoff_date_label'),
          milesAway: t('common_new_main_widget:miles_away'),
          baseErrorHeader: t('common_new_main_widget:base_error_header'),
          warning: t('common_new_main_widget:warning'),
          warningNote: t('common_new_main_widget:warning_note'),
          saveUpTo: t('common_new_main_widget:save_up_to'),
          closedAlertText: t('common_new_main_widget:closed_alert'),
          timeLabel: t('common_new_main_widget:time'),
          reserveBtnLabel: t('common_new_main_widget:reserve'),
          vehiclesLabel: t('common_new_main_widget:vehicles'),
        },
      },
    }),
    [t],
  );

  return data;
};

export { useGeoCMSData };